import { render, staticRenderFns } from "./PricingPlanHistoryModal.vue?vue&type=template&id=db108816&lang=true"
import script from "./PricingPlanHistoryModal.vue?vue&type=script&lang=js"
export * from "./PricingPlanHistoryModal.vue?vue&type=script&lang=js"
import style0 from "./PricingPlanHistoryModal.vue?vue&type=style&index=0&id=db108816&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports